import { Input } from "./ui/input";

// Saisie d'une durée en heures + minutes ; valeur exposée en minutes (ou
// null si vide — durée facultative).
export function DurationInput({ value, onChange, idPrefix = "duree" }) {
  const total = value ? Number(value) : 0;
  const h = value ? Math.floor(total / 60) : "";
  const m = value ? total % 60 : "";
  const update = (hh, mm) => {
    const H = parseInt(hh || 0, 10) || 0;
    const M = parseInt(mm || 0, 10) || 0;
    const t = H * 60 + M;
    onChange(t > 0 ? t : null);
  };
  return (
    <div className="flex items-center gap-2">
      <div className="relative w-24">
        <Input type="number" min="0" max="999" value={h} placeholder="0" onChange={(e) => update(e.target.value, m)} data-testid={`${idPrefix}-heures`} className="pr-7" />
        <span className="absolute right-2.5 top-1/2 -translate-y-1/2 text-xs text-muted-foreground">h</span>
      </div>
      <div className="relative w-24">
        <Input type="number" min="0" max="59" step="5" value={m} placeholder="0" onChange={(e) => update(h, e.target.value)} data-testid={`${idPrefix}-minutes`} className="pr-10" />
        <span className="absolute right-2.5 top-1/2 -translate-y-1/2 text-xs text-muted-foreground">min</span>
      </div>
    </div>
  );
}
